<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px;">
      <div class="modal-header">
        <div class="title">详情</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="max-height: 400px;" v-loading="loading">


        <div v-if="data !=null">


          <el-row>
            <el-col :span="24" class="item">
              <el-steps :space="200" :active="data.orderBusiness.status-10" finish-status="success">
                <el-step title="待付款"></el-step>
                <el-step title="待接单"></el-step>
                <el-step title="待服务"></el-step>
                <el-step title="服务中"></el-step>
                <el-step title="已完成"></el-step>
                <el-step title="已取消"></el-step>
                <el-step title="已评价"></el-step>
                <el-step title="已退单"></el-step>
              </el-steps>
            </el-col>
          </el-row>

          <el-row class="row">
            <el-col :span="6" class="item">
              <div class="label">订单号</div>
              <el-input v-model="data.orderBusiness.serialNumber" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">总价</div>
              <el-input v-model="data.orderBusiness.price" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">付款类型</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">
                <div v-if="data.orderBusiness.payType == 'wx' ">微信</div>
                <div v-if="data.orderBusiness.payType == 'ali' ">支付宝</div>
                <div v-if="data.orderBusiness.payType == 'yue' ">余额</div>
                <div v-if="data.orderBusiness.payType == 'cash' ">现金</div>
              </el-button>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">订单状态</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">
                <div v-if="data.orderBusiness.status =='10' ">待付款</div>
                <div v-if="data.orderBusiness.status =='11' ">待接单</div>
                <div v-if="data.orderBusiness.status =='12' ">待服务</div>
                <div v-if="data.orderBusiness.status =='13' ">服务中</div>
                <div v-if="data.orderBusiness.status =='14' ">已完成</div>
                <div v-if="data.orderBusiness.status =='15' ">已取消</div>
                <div v-if="data.orderBusiness.status =='16' ">已评价</div>
                <div v-if="data.orderBusiness.status =='17' ">已退单</div>
              </el-button>
            </el-col>

            <el-col :span="6" class="item">
              <div class="label">创建时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderBusiness.createTime)}}</el-button>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">付款时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderBusiness.payTime)}}</el-button>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">预约时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderBusiness.planTime)}}</el-button>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">完成时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderBusiness.completeTime)}}</el-button>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="6" class="item">
              <div class="label">收货人</div>
              <el-input v-model="data.order.receiveName" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">收货人手机</div>
              <el-input v-model="data.order.receivePhone" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">收货人地区</div>
              <el-input v-model="data.order.receiveAreaPath" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">收货人地址</div>
              <el-input v-model="data.order.receiveAddress" disabled size="mini"></el-input>
            </el-col>
          </el-row>

          <el-row class="row">

            <el-col :span="6" class="item">
              <div class="label">商家</div>
              <el-input v-model="data.orderBusiness.businessName" disabled size="mini"></el-input>
            </el-col>

            <el-col :span="6" class="item" v-if="data.orderServeDTO !=null">
              <div class="label">服务人员</div>
              <el-input v-model="data.orderServeDTO.userDTO.name" disabled size="mini"></el-input>
            </el-col>

          </el-row>


          <el-row style="margin-top:20px">
            <el-col :span="24" class="item">
              <div class="label">服务项目</div>
              <el-table class="table" size="mini" :data="data.listOrderGoodsDTO" border>
                <el-table-column prop="imgPath" label="图片">
                  <template slot-scope="scope">
                    <el-image :src="imgHost+scope.row.goodsImg" style="width: 40px;height: 40px;"/>
                  </template>
                </el-table-column>
                <el-table-column prop="goodsName" label="服务项目"></el-table-column>
                <el-table-column prop="goodsPrice" label="单价" ></el-table-column>
                <el-table-column prop="number" label="数量" ></el-table-column>
              </el-table>
            </el-col>
          </el-row>



          <el-row style="margin-top:20px" v-if="data.orderServeRecordDTOStart !=null">
            <el-col :span="6" class="item">
              <div class="label">开始服务</div>
              <el-table class="table" size="mini" :data="data.orderServeRecordDTOStart.listOrderServeRecordImg" border>
                <el-table-column prop="imgPath" label="图片">
                  <template slot-scope="scope">
<!--                    <el-image :src="imgHost+scope.row.imgPath" style="width: 40px;height: 40px;"/>-->
                    <el-popover placement="right" trigger="click">
                      <img :src="imgHost+scope.row.imgPath+'_watermark.jpg'" style="width: 400px"/>
                      <img slot="reference" :src="imgHost+scope.row.imgPath+'_watermark.jpg'" style="width:60px">
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">开始时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderServeRecordDTOStart.createTime)}}</el-button>
            </el-col>
            <el-col :span="12" class="item">
              <div class="label">开始备注</div>
              <el-input v-model="data.orderServeRecordDTOStart.remark" disabled size="mini"></el-input>
            </el-col>
          </el-row>

          <el-row v-if="data.orderServeRecordDTOEnd !=null">
            <el-col :span="6" class="item">
              <div class="label">结束服务</div>
              <el-table class="table" size="mini" :data="data.orderServeRecordDTOEnd.listOrderServeRecordImg" border>
                <el-table-column prop="imgPath" label="图片">
                  <template slot-scope="scope">
<!--                    <el-image :src="imgHost+scope.row.imgPath" style="width: 40px;height: 40px;"/>-->
                    <el-popover placement="right" trigger="click">
                      <img :src="imgHost+scope.row.imgPath+'_watermark.jpg'" style="width: 400px"/>
                      <img slot="reference" :src="imgHost+scope.row.imgPath+'_watermark.jpg'" style="width:60px">
                    </el-popover>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">结束时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderServeRecordDTOEnd.createTime)}}</el-button>
            </el-col>
            <el-col :span="12" class="item">
              <div class="label">结束备注</div>
              <el-input v-model="data.orderServeRecordDTOEnd.remark" disabled size="mini"></el-input>
            </el-col>
          </el-row>

          <el-row style="margin-top:20px" v-if="data.orderBusinessAppraise !=null">
            <el-col :span="6" class="item">
              <div class="label">评价时间</div>
              <el-button disabled size="mini" style="width: 100%;text-align: left;">{{timefilter2(data.orderBusinessAppraise.createTime)}}</el-button>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">语音评价</div>
              <el-button v-if="data.orderBusinessAppraise.amrPath == null" disabled size="mini" style="width: 100%;text-align: left;">null</el-button>
              <el-button v-if="data.orderBusinessAppraise.amrPath != null" size="mini"
                         @click="playAudio(data.orderBusinessAppraise.amrPath)"
                         style="width: 100%;text-align: left;">播放>></el-button>
            </el-col>
            <el-col :span="12" class="item">
              <div class="label">评价内容</div>
              <el-input v-model="data.orderBusinessAppraise.remarks" disabled size="mini"></el-input>
            </el-col>
            <el-col :span="6" class="item">
              <div class="label">服务对象签名</div>
              <el-popover placement="right" trigger="click">
                <img :src="imgHost+data.orderBusinessAppraise.signPath+'_2000x2000.jpg'" style="width: 400px"/>
                <img slot="reference" :src="imgHost+data.orderBusinessAppraise.signPath+'_310x310.jpg'" style="width:60px">
              </el-popover>
            </el-col>
          </el-row>


        </div>


      </div>
    </div>

  </div>
</template>


<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import BenzAMRRecorder from "benz-amr-recorder";

export default {
  name: 'Add',
  data() {
    return {

      loading: false,

      orderBusinessCode:'',

      data:null,

      imgHost:this.$imgUrl,

    }
  },
  methods: {

    init(orderBusinessCode){
      this.orderBusinessCode = orderBusinessCode;
      this.getDetail();

    },
    closeSelf() {
      this.$emit("closeInfo");
    },


    getDetail(){

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"OrderBusiness/OrderDetail2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          orderBusinessCode: this.orderBusinessCode,
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.error === 0) {
          this.data = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },

    timefilter2(cellValue) {
      if(cellValue == null){
        return '-';
      }
      return timefilters(cellValue)
    },

    // 音频播放
    playAudio(url) {
      //this.mediaUrl = url

      let ss = url.substring(url.indexOf("/files/"));
      url = this.imgHost + ss;
      console.log(url);

      if(this.isPlay){
        this.isPlay = false
        if(this.amr.isPlaying()){
          this.amr.stop();//停止
        }
      }
      else{
        var BenzAMRRecorder = require('benz-amr-recorder');
        this.amr = new BenzAMRRecorder();
        this.isPlay = true
        this.amr.initWithUrl(url).then(()=> {
          this.amr.play();
        });
        this.amr.onEnded(()=> {
          this.isPlay = false
        })
      }

    },


  }
}
</script>


